<template>
    <div v-if="gameBanner && gameBanner.game" class="game-banner" @click="openGame(gameBanner.game)">
        <img v-if="gameBanner.img" class="game-banner__img" :src="gameBanner.img" :alt="gameBanner.category">
    </div>
</template>
<script>
import Vue from 'vue';

export default {
    name: 'game-banner',
    computed: {
        client() {
            return Vue.state.client.get().view.general.alias;
        },
        category() {
            return this.$route.name;
        },
        gameBanner() {
            return this.client && this.category && Vue.state.gameBanners.get(this.client, this.category);
        }
    },
    methods: {
        async openGame(game) {
            await Vue.router.teleport.game(game);
        }
    }
}
</script>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/game-banners/game-banner.vue